import { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useT } from "../i18n";
import LangToggle from "./LangToggle";

const Header = ({ userInfo, logout }) => {
    const t = useT();
    const [btnHover, setBtnHover] = useState("");
    const navigate = useNavigate();
    const location = useLocation();
    const [loginBtnState, setLoginBtnState] = useState("");
    
    useEffect(() => {
        if (window.location.href.split("/").pop() === "login") {
            setLoginBtnState("disabled");
        }
    }, []);

    // 현재 경로가 해당 메뉴와 일치하는지 확인하는 함수
    const isActive = (path) => {
        return location.pathname === path ? "active" : "";
    };

    return (
        <div className="header_bg notFullpage">
            <header>
                <input
                    className="burger-check"
                    type="checkbox"
                    id="burger-check"
                />
                <label className="burger-icon" htmlFor="burger-check">
                    <span className="burger-sticks"></span>
                </label>
                <div className="menu">
                    <ul className="menu_contents">
                        {userInfo === null ? (
                            <li className={`${loginBtnState}`}>
                                <Link
                                    to="/login"
                                    state={{ returnUrl: window.location.href }}
                                >
                                    {t('Log In')}
                                </Link>
                            </li>
                        ) : (
                            <>
                                <li>
                                    <a onClick={logout} href="#">
                                        {t('Log Out')}
                                    </a>
                                </li>
                            </>
                        )}
                        <li className={`about ${isActive("/about")}`}>
                            <Link to="/about">{t('About')}</Link>
                        </li>
                        {/* <li className={isActive("/project")}>
                            <a href="/project">Project</a>
                        </li> */}
                        <li className={`people ${isActive("/people")}`}>
                            <Link to="/people">{t('People')}</Link>
                        </li>
                        <li className={`news ${isActive("/news")}`}>
                            <Link to="/news">{t('News')}</Link>
                        </li>
                        {userInfo !== null && (
                            <li className={`mypage ${isActive("/mypage")}`}>
                                <Link to="/mypage">{t('My page')}</Link>
                            </li>
                        )}
                        <li className="lang">
                            <LangToggle />
                        </li>
                    </ul>
                </div>
                <h1>
                    <Link to="/">
                        <img src="images/logoBlack.png" alt={t("프롭메이트 로고")} />
                    </Link>
                </h1>
                <div
                    className={`btns btn_map ${btnHover}`}
                    onClick={() => {
                        navigate("/map");
                    }}
                >
                    <img
                        src={process.env.PUBLIC_URL + "images/icon_map_go.png"}
                    ></img>
                    <div className="hover_box">{t("지도 보러가기")}</div>
                </div>
            </header>
        </div>
    );
};

export default Header;